import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';

function getBiActivityPoints(profileId, pageSize = 10, pageNumber = 1) {
    const biAccountId = userUtils.getBiAccountId();
    const path = `/gway/v1/lxs/${biAccountId}/point-activity-groups`;
    const url = `${path}?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    const headers = {
        'x-requested-source': 'web'
    };

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => {
        return !data || data.errorCode || data?.responseStatus === 500 ? Promise.reject(data) : data;
    });
}

export default getBiActivityPoints;
